import { useDispatch } from "react-redux";
import { showNotification, hideNotification } from "../Redux/Notification/NotificationSlice";

const useNotification = () => {
  const dispatch = useDispatch();

  const notify = (message, type = "info") => {
    dispatch(showNotification({ message, type }));
    
    setTimeout(() => {
      dispatch(hideNotification());
    }, 3000);
  };

  return notify;
};

export default useNotification;
